import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Payment\PaymentExportController::__invoke
* @see app/Http/Controllers/Payment/PaymentExportController.php
* @route '/api/payment/export-excel'
*/
const PaymentExportController = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: PaymentExportController.url(options),
    method: 'post',
})

PaymentExportController.definition = {
    methods: ["post"],
    url: '/api/payment/export-excel',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Payment\PaymentExportController::__invoke
* @see app/Http/Controllers/Payment/PaymentExportController.php
* @route '/api/payment/export-excel'
*/
PaymentExportController.url = (options?: RouteQueryOptions) => {
    return PaymentExportController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Payment\PaymentExportController::__invoke
* @see app/Http/Controllers/Payment/PaymentExportController.php
* @route '/api/payment/export-excel'
*/
PaymentExportController.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: PaymentExportController.url(options),
    method: 'post',
})

export default PaymentExportController